import {
  type Action,
  canImportNesting,
  can as policy,
  type Resource,
  type Role,
} from '@veem/crm-schema'

export type { Action, Resource, Role } from '@veem/crm-schema'
export {
  canAccessProductionPlan,
  canAccessProductionScrap,
  canConfigureProductionProgress,
  canCreateInternalProductionOrder,
  isCncWorkCenter,
  isProductionLead,
  managesWorkCenter,
} from '@veem/crm-schema'

export const can = (role: Role, resource: Resource, action: Action) =>
  policy({ id: '', role }, action, resource)

/** «Завантажити карту розкрою»: the shop manager or the storekeeper. */
export const canImportNestingReport = (role: Role) => canImportNesting({ id: '', role })
